import { Horizontal, Texto } from '@gravitate-js/excalibrr'
import { IconCalendarCheck, IconCalendarClock, IconCancel, IconCircleCheckFilled } from '@tabler/icons-react'
import type { ICellRendererParams } from 'ag-grid-community'
import _ from 'lodash'
import React from 'react'

export function StatusRenderer({ value }: ICellRendererParams<Gravitate.SupplyOutage>) {
  let icon
  switch (value.toLowerCase()) {
    case 'active':
      icon = <IconCircleCheckFilled size={18} fill='var(--theme-success)' />
      break
    case 'cancelled':
      icon = <IconCancel size={18} color='var(--theme-error)' strokeWidth={2} />
      break
    case 'completed':
      icon = <IconCalendarCheck size={18} />
      break
    default:
      icon = <IconCalendarClock size={18} />
  }
  return (
    <Horizontal verticalCenter>
      <div style={{ display: 'flex' }}>{icon}</div>
      <Texto className='ml-2'>{_.startCase(value)}</Texto>
    </Horizontal>
  )
}
